module.exports = __webpack_public_path__ + "static/img/gift-box-reward-bottom.1189846.png";